import { render } from "./SwitchControlPanel.vue?vue&type=template&id=150dca48"
import script from "./SwitchControlPanel.vue?vue&type=script&lang=js"
export * from "./SwitchControlPanel.vue?vue&type=script&lang=js"
script.render = render

export default script